import { Component, inject } from "@angular/core";

import { MediaQueryOption } from "@hermes/aphrodite/media-picture";
import {
    EditorialBlockDeprecated,
    PushEditorialSelectionDeprecated,
} from "@hermes/api-model-editorial";

import { isCTALink } from "@hermes/fragments/editorial-cta-resolver";

import { CHAPTERS_PARAGRAPH, SHOULD_PRELOAD_MEDIA } from "../../core";

@Component({
    selector: "h-editorial-selection",
    templateUrl: "./editorial-selection.component.html",
    styleUrls: ["./editorial-selection.component.scss"],
    standalone: false,
})
export class EditorialSelectionComponent {
    editorialSelection =
        inject<PushEditorialSelectionDeprecated>(CHAPTERS_PARAGRAPH);
    public shouldPreloadMedia = inject(SHOULD_PRELOAD_MEDIA);

    public mediaOptions = pushEditorialSelectionOptions;

    public setToken(blockEdito: EditorialBlockDeprecated) {
        if (isCTALink(blockEdito.token)) {
            return blockEdito.token.path;
        }
        return undefined;
    }
}

const pushEditorialSelectionOptions: MediaQueryOption[] = [
    {
        size: "xsmall",
        mediaQuery: "(min-width: 320px) and (max-width: 414px)",
        width: 308,
    },
    {
        size: "small",
        mediaQuery: "(min-width: 415px) and (max-width: 767px)",
        width: 572,
    },
    {
        size: "medium",
        mediaQuery: "(min-width: 768 px) and (max-width: 1024px)",
        width: 762,
    },
    {
        size: "large",
        mediaQuery: "(min-width: 1025px) and (max-width: 1280px)",
        width: 464,
    },
    {
        size: "xlarge",
        mediaQuery: "(min-width: 1281px) and (max-width: 1920px)",
        width: 696,
    },
    { size: "xxlarge", mediaQuery: "(min-width: 1921px)", width: 696 },
];
